import { render, staticRenderFns } from "./Faculty.vue?vue&type=template&id=b438dc54&scoped=true&"
import script from "./Faculty.vue?vue&type=script&lang=js&"
export * from "./Faculty.vue?vue&type=script&lang=js&"
import style0 from "./Faculty.vue?vue&type=style&index=0&id=b438dc54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b438dc54",
  null
  
)

export default component.exports